import { createFileRoute, redirect } from "@tanstack/react-router";
import { parseMerchantLoginSearch } from "@/components/auth/MerchantLoginPage";

export const Route = createFileRoute("/login")({
  validateSearch: parseMerchantLoginSearch,
  beforeLoad: ({ search }) => {
    throw redirect({
      to: "/acceso/comercio",
      search: {
        returnTo: search.returnTo,
        error: search.error,
      },
      replace: true,
    });
  },
});
